import { render, staticRenderFns } from "./training-preview.component.vue?vue&type=template&id=52de990a&scoped=true"
import script from "./training-preview.component.ts?vue&type=script&lang=ts&external"
export * from "./training-preview.component.ts?vue&type=script&lang=ts&external"
import style0 from "./training-preview.component.scss?vue&type=style&index=0&id=52de990a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52de990a",
  null
  
)

export default component.exports